import {
  JOB_SEEKER_ADD_NEW,
  JOB_SEEKER_ADD_NEW_SUCCESS,
  JOB_SEEKER_ADD_NEW_ERROR,
  JOB_SEEKER_DELETE,
  JOB_SEEKER_DELETE_ERROR,
  JOB_SEEKER_DELETE_SUCCESS,
  JOB_SEEKER_EDIT,
  JOB_SEEKER_EDIT_ERROR,
  JOB_SEEKER_EDIT_SUCCESS,
  JOB_SEEKER_GET_BY_ID,
  JOB_SEEKER_GET_BY_ID_ERROR,
  JOB_SEEKER_GET_BY_ID_SUCCESS,
  JOB_SEEKER_GET_LIST,
  JOB_SEEKER_GET_LIST_ERROR,
  JOB_SEEKER_GET_LIST_SUCCESS,
  JOB_SEEKER_ADD_NEW_REQUEST,
} from '../actions';

const initialState = {
  jobSeekers: [],
  jobSeeker: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case JOB_SEEKER_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case JOB_SEEKER_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        jobSeeker: payload,
      };

    case JOB_SEEKER_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case JOB_SEEKER_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case JOB_SEEKER_GET_LIST_SUCCESS:
      return {
        ...state,
        jobSeekers: payload,
        loading: true,
      };
    case JOB_SEEKER_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case JOB_SEEKER_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        jobSeeker: payload,
        jobSeekers: state.jobSeekers.concat(payload),
        addSuccess: true,
      };

    case JOB_SEEKER_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case JOB_SEEKER_EDIT_SUCCESS:
      return {
        ...state,
        jobSeekers: state.jobSeekers.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        jobSeeker: payload,
        error: null,
        editSuccess: true,
      };
    case JOB_SEEKER_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case JOB_SEEKER_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        jobSeekers: state.jobSeekers.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case JOB_SEEKER_DELETE_ERROR:
    case JOB_SEEKER_ADD_NEW_ERROR:
    case JOB_SEEKER_EDIT_ERROR:
    case JOB_SEEKER_GET_BY_ID_ERROR:
    case JOB_SEEKER_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
